import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import type { statisticsParmam } from '@src/services/myInterface';
import { type callAppParmam } from '@src/services/myInterface';
import styles from './index.css';
import banner from './assets/banner.png';

type BrandProps = {
    content: {
        callAppData?: callAppParmam;
        statData?: statisticsParmam;
        needPlaceholder?: boolean;
    };
};

const Brand = ({ content }: BrandProps) => {
    const { callAppData, statData, needPlaceholder = true } = content;

    const wxLaunchHackData = {
        callAppConfig: callAppData,
        statisticsConfig: statData,
    };

    return (
        <>
            <div className={styles.brandBox}>
                <img className={styles.brandPic} src={banner} alt="" />
                <WxLaunchHack content={wxLaunchHackData} />
            </div>
            {needPlaceholder && <div className={styles.brand} />}
        </>
    );
};

export default errorBoundary(Brand);
